import winner from "./winner.png";
import logo from "./logo.png";

import image1 from "./1.jpeg";
import image2 from "./2.jpeg";
import image3 from "./3.jpeg";
import image4 from "./4.jpeg";

export { winner, logo, image1, image2, image3, image4 };
